import React, { FC, useState } from 'react';
import { User } from 'api/models';
import { UserAPI } from 'api/user';
import { ImageUpload } from 'components/molecules/image-upload';
import { toastService } from 'components/molecules/toast';
import { useTranslation } from 'hooks/use-translation';
import { useUpdateCurrentUserMutation } from 'queries';
import { fullName } from 'utils/full-name';

export const ChangeProfilePic: FC<{ user: User }> = ({ user }) => {
  const [isUploading, setIsUploading] = useState(false);
  const successToastTitle = useTranslation(
    'settings.profile.profile_pic.success.title',
  );
  const successToastMsg = useTranslation(
    'settings.profile.profile_pic.success.message',
  );
  const errorToastMsg = useTranslation(
    'settings.profile.change_profile_pic.error',
  );
  const buttonText = `${useTranslation('change_picture')}...`;
  const errorTitle = useTranslation('avatar.upload.error.title');

  const { mutate } = useUpdateCurrentUserMutation();

  const uploadProfilePic = ({ file }) => {
    setIsUploading(true);
    UserAPI.uploadProfilePic(file)
      .then(({ location: photoUrl }) => {
        mutate(
          { photoUrl },
          {
            onSuccess: () => {
              toastService({
                title: successToastTitle,
                message: successToastMsg,
              }).success();
            },
            onError: () => {
              toastService({
                title: errorTitle,
                message: 'Something went wrong',
              }).error();
            },
            onSettled: () => {
              setIsUploading(false);
            },
          },
        );
      })
      .catch(() => {
        toastService({
          title: errorTitle,
          message: errorToastMsg,
        }).error();
        setIsUploading(false);
      });
  };

  return (
    <ImageUpload
      onUpload={uploadProfilePic}
      src={user.photoUrl}
      alt={fullName(user)}
      isLoading={isUploading}
      buttonText={buttonText}
      showSizeRestriction
    />
  );
};
